import CircleIcon from '@mui/icons-material/Circle';
import { Tooltip } from '@mui/material';

export enum ConnectivityStatus {
  Online,
  Offline,
  NotFound,
}

type Params = {
  status: string;
};

function StatusIndicator({ status }: Params) {
  const statusEnum =
    ConnectivityStatus[status as keyof typeof ConnectivityStatus];

  const statusColorMap = {
    [ConnectivityStatus.Online]: '#199a19',
    [ConnectivityStatus.Offline]: '#f10808',
    [ConnectivityStatus.NotFound]: '#c6c3c3',
  };
  const statusColor = statusColorMap[statusEnum];

  return (
    <div>
      <Tooltip title={status} arrow>
        <CircleIcon sx={{ color: statusColor, marginLeft: '2.5rem' }} />
      </Tooltip>
    </div>
  );
}

export default StatusIndicator;
